module.exports = __webpack_public_path__ + "static/media/jungleBeats.fe4fb509.ogg";